/* eslint-disable */
import { PaginationControl } from "react-bootstrap-pagination-control";
import React, { useRef, useState, useEffect } from 'react'
// Before
import styled from 'styled-components'


import SideBar from '../components/views/SideBar'
import {
  AiOutlinePlus,
  AiTwotoneFilter,

} from 'react-icons/ai'
import { FaFileExport, FaRegEdit, FaRegTrashAlt } from 'react-icons/fa'
import axios from 'axios'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'
import { Link } from 'react-router-dom'
import apiInstance from '../utils/api'
import Swal from "sweetalert2";
import calculateAge from "../features/autoIncreaseAge";

const Top = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
`

const Left = styled.div`
  font-weight: normal;
  flex: 2;
`

const Title = styled.h5`
  font-weight: bold;
  margin-top: 10px;
`

const Right = styled.div`
  font-weight: normal;
  flex: 1;
  display: flex;
  justify-content: flex-end;
`

const Button = styled.button`
  background: #007bff;
  color: white;
  justify-content: flex-end;
  padding: 5px 10px;
  border: none;
  border-radius: 10px;
`

const Btn = styled.button`
  padding: 4px 8px;
  border-radius: 5px;
  margin-left: 13px;
`

const Div = styled.div``
const Input = styled.input`
  width: 300px;
  border: 1px solid grey;
  border-radius: 12px;
  padding: 3px;
`
const Table = styled.table``
const Thead = styled.thead``
const Tbody = styled.tbody``
const Tr = styled.tr`
  text-align: center;
`
const Th = styled.th`
  font-size: 15px;
`
const Td = styled.td`
  font-size: 14px;
`
const Select = styled.select`
  padding: 0px 7px;
  border-radius: 5px;
`
const Option = styled.option``
// const DataTable = DataTables(window, $)

const Patient = () => {
  const [patients, setPatients] = useState([])
  const [allpatientsOld, setAllPatients] = useState([])
  const [patientsNew, setPatientsNew] = useState([])
  const [allpatientsNew, setAllPatientsNew] = useState([])
  const [isOpen, setIsOpen] = useState(false)
  const [value, setValue] = useState('')
  const [showSearch, setShowSearch] = useState(false);
  const [searchList, setSearchList] = useState([]);
  const [showOri, setShowOri] = useState(true);
  const [page, setPage] = useState(1);
  const [pages, setPages] = React.useState("");
  const [dataCount, setDataCount] = useState("");
  const [rowsPerPage, setRowsPerPage] = React.useState(50);
  const paginationItems = React.useMemo(() => {
    const start = (page - 1) * rowsPerPage;
    const end = start + rowsPerPage;
    return searchList[0] ? searchList.slice(start, end) : patients.slice(start, end);
  }, [page, patients, searchList]);

  const handleDelete = async (id) => {
    // console.log(id, "event");
    apiInstance
      .delete("patient/" + id)
      .then((response) => {
        Swal.fire({
          title: "Success",
          text: "Successfully Deleted!",
          icon: "success",
          showConfirmButton: false,
          timer: 3000
        });
        const result = patients.filter((item) => item._id !== id);
        setPatients(result);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  }

  useEffect(() => {
    const getPatients = async () => {
      try {
        const res = await apiInstance.get(
          'patients'
        )

        setPatients(res.data.data.filter(el => el.patientStatus == 'Old'))

        setAllPatients(res.data.data.filter(el => el.patientStatus == 'Old'))
        setPatientsNew(res.data.data.filter(el => el.patientStatus == 'New'))
        setAllPatientsNew(res.data.data.filter(el => el.patientStatus == 'New'))
        setDataCount(
          res.data.data.length
        );
        setPages(
          res.data.data.length %
            rowsPerPage ===
            0
            ? res.data.data.length /
            rowsPerPage
            : Math.floor(
              res.data.data.length /
              rowsPerPage
            ) + 1
        );
      } catch (err) { }
    }
    getPatients()
  }, [])




  const search = (value) => {
    if (value) {
      const resData = patients.filter(
        (el) =>
          el.patientID?.toLowerCase().includes(value.toLowerCase()) ||
          el.name?.toLowerCase().includes(value.toLowerCase()) ||
          el.phone?.toLowerCase().includes(value.toLowerCase())

      )
      // console.log(resData, 'resData')
      setSearchList(
        resData
      );
      setShowOri(false)
      setShowSearch(true)
      setDataCount(
        resData.length
      );
      setPages(
        resData.length %
          rowsPerPage ===
          0
          ? resData.length /
          rowsPerPage
          : Math.floor(
            resData.length /
            rowsPerPage
          ) + 1
      );

    } else {
      setShowOri(true)
      setShowSearch(false)
    }

    // console.log(
    //   accountLists.filter(
    //     el =>
    //       el.subHeader == name ||
    //       el.relatedType.name == name ||
    //       el.relatedHeader.name == name
    //   ),
    //   'search'
    // )
  };
  const show = () => setIsOpen(!isOpen)

  return (
    <div className='wrapper'>
      <SideBar />
      {/* <!-- Content Wrapper. Contains page content --> */}

      <div className='content-wrapper'>
        {/* <!-- Content Header (Page header) --> */}
        <div className='content-header'>
          <div className='container-fluid'>
            <Top>
              <Left>
                <Title>Patient List</Title>
              </Left>
              <Right>
                <Link to='/patient/register'>
                  <Button>
                    <AiOutlinePlus style={{ marginRight: '7px' }} />
                    Patient Register
                  </Button>
                </Link>
              </Right>
            </Top>
            <Div className='card'>
              <Div className='card-body'>
                {/* <Tabs>
                <TabList>
                    <Tab>Old</Tab>
                    <Tab>New</Tab>
                  </TabList>
            </Tabs>
                <TabPanel> */}
                <Top className='mt-4'>
                  <Left >
                    <Input type='text' className='p-2' onChange={(e) => search(e.target.value)} placeholder='Search name,code,phone ...' />
                  </Left>
                  <Right>
                    {/* {isOpen && (
                      <Select onChange={e => genderfilter(e.target.value)}>
                        <Option>Gender</Option>
                        <Option value='1'>Male</Option>
                        <Option value='2'>Female</Option>
                      </Select>
                    )} */}
                    {/* <Btn
                      onClick={handleSort}
                      className='btn btn-outline-primary'
                    >
                      Sort
                    </Btn> */}
                    {/* <Btn className='btn btn-outline-primary'>
                      <AiTwotoneFilter onClick={show} />
                    </Btn>
                    <Btn className='btn btn-outline-success'>
                      <FaFileExport />
                    </Btn> */}
                  </Right>
                </Top>
                <Table className='table table-hover mt-4'>
                  <Thead>
                    <Tr>
                      <Th>#</Th>
                      <Th>Patient Id</Th>
                      <Th>Name</Th>
                      <Th>Age</Th>
                      <Th>Phone</Th>

                      <Th>Gender</Th>
                      <Th>Address</Th>
                      <Th>Allergy History</Th>
                      <Th>Action</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {showOri === true ? (

                      paginationItems[0] ? paginationItems.map((patient, i) => (
                        <Tr>
                          {/* To change serial number */}
                          <Td>{(page - 1) * rowsPerPage + i + 1}</Td>
                          <Td>{patient?.patientID}</Td>
                          <Td>{patient?.name}</Td>
                          <Td>{calculateAge(patient?.dateOfBirth) || patient?.age}</Td>
                          <Td>{patient?.phone}</Td>
                          <Td>{patient?.gender}</Td>
                          <Td>{patient?.address}</Td>
                          <Td>{patient?.allergyHistory ? patient?.allergyHistory : '-'}</Td>
                          {/* <Td><Link to={'/test_sale/'+patient._id} class="btn btn-primary">Test Voucher</Link></Td> */}
                          <Td>
                            <Link
                              to={'/test_voucher/' + patient._id}
                              class='btn btn-sm btn-primary'
                            >
                              Test Voucher
                            </Link>
                            &nbsp;
                            <Link to={'/patient/' + patient._id} class="btn btn-sm btn-warning"><FaRegEdit /></Link>
                            &nbsp;
                            <button onClick={() => handleDelete(patient._id)} class="btn btn-sm btn-danger"><FaRegTrashAlt /></button>

                          </Td>
                        </Tr>

                      )) : (
                        <div className='py-3 d-flex justify-content-center'>

                          {/* <img src={SearchIcon} width='70px' /> */}
                          <span className='text-md'>Loading . . .</span>

                        </div>
                      )
                    ) : (
                      paginationItems[0] ? paginationItems.map((patient, i) => (
                        <Tr>
                          {/* To change serial number */}
                          <Td>{(page - 1) * rowsPerPage + i + 1}</Td>
                          <Td>{patient?.patientID}</Td>
                          <Td>{patient?.name}</Td>
                          <Td>{calculateAge(patient?.dateOfBirth) || patient?.age}</Td>
                          <Td>{patient?.phone}</Td>
                          <Td>{patient?.gender}</Td>
                          <Td>{patient?.address}</Td>
                          <Td>{patient?.allergyHistory ? patient?.allergyHistory : '-'}</Td>
                          {/* <Td><Link to={'/test_sale/'+patient._id} class="btn btn-primary">Test Voucher</Link></Td> */}
                          <Td>
                            <Link
                              to={'/test_voucher/' + patient._id}
                              class='btn btn-sm btn-primary'
                            >
                              Test Voucher
                            </Link>
                            &nbsp;
                            <Link to={'/patient/' + patient._id} class="btn btn-sm btn-warning"><FaRegEdit /></Link>
                            &nbsp;
                            <button onClick={() => handleDelete(patient._id)} class="btn btn-sm btn-danger"><FaRegTrashAlt /></button>

                          </Td>
                        </Tr>

                      )) : (
                        <div className='py-3 d-flex justify-content-center'>

                          {/* <img src={SearchIcon} width='70px' /> */}
                          <span className='text-md'>Loading . . .</span>

                        </div>
                      )
                    )}

                  </Tbody>
                </Table>
                {/* </TabPanel> */}
                {/* <TabPanel>
                    <Top className="mt-4">
                      <Left>
                        <Input type="text" placeholder="Search..." />
                      </Left>
                      <Right>
                        {isOpen && (
                          <Select
                            onChange={(e) => genderfilterNew(e.target.value)}>
                            <Option>Gender</Option>
                            <Option value="1">Male</Option>
                            <Option value="2">Female</Option>
                          </Select>
                        )}
                        <Btn className="btn btn-outline-primary">
                          <AiTwotoneFilter onClick={show} />
                        </Btn>
                        <Btn className="btn btn-outline-success">
                          <FaFileExport />
                        </Btn>
                      </Right>
                    </Top>
                    <Table className="table table-hover mt-4">
                      <Thead>
                        <Tr>
                          <Th>#</Th>
                          <Th>Patient Id</Th>
                          <Th>Name</Th>
                          <Th>Age</Th>
                          <Th>Phone</Th>
                          <Th>Date of Birth</Th>
                          <Th>Gender</Th>
                          <Th>Address</Th>
                          <Th>Action</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {patientsNew.map((patient, i) => (
                          <Tr>
                            <Td>{++i}</Td>
                            <Td>{patient.patientID}</Td>
                            <Td>{patient.name}</Td>
                            <Td>{patient.age}</Td>
                            <Td>{patient.phone}</Td>
                            <Td>{patient.dateOfBirth.split("T")[0]}</Td>
                            <Td>{patient.gender}</Td>
                            <Td>{patient.address}</Td>
                            <Td>
                              <Link
                                to={"/test_voucher/" + patient._id}
                                class="btn btn-sm btn-primary">
                                Test Voucher
                              </Link>
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </TabPanel> */}
                {/* </Tabs> */}
              </Div>
              <div className='mt-4'>
                <PaginationControl
                  page={page}
                  between={4}
                  total={dataCount}
                  limit={50}
                  changePage={(page) => {
                    setPage(page);
                  }}
                  ellipsis={1}
                />
              </div>
            </Div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Patient
